(() => {
  if (customElements.get('ecomax-landing')) return;
  class EcomaxLanding extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.addEventListener('click', event => {
        const request = event.target.closest('a[data-ecomax-request]');
        if (request && this.contains(request)) {
          event.preventDefault();
          this.openQuote(request);
          return;
        }
        const link = event.target.closest('a[data-ecomax-quote]');
        if (!link || !this.contains(link)) return;
        const url = new URL(link.href);
        url.searchParams.set('text', this.attributeMessage(url.searchParams.get('text') || ''));
        link.href = url.href;
        this.track(link.dataset.source, link.dataset.model || '');
      }, { signal });
      this.dialog = this.querySelector('[data-ecomax-dialog]');
      this.emailForm = this.querySelector('[data-ecomax-email-form]');
      this.querySelector('[data-close-quote]')?.addEventListener('click', () => this.dialog.close(), { signal });
      this.dialog?.addEventListener('click', event => {
        const bounds = this.dialog.getBoundingClientRect();
        if (event.target === this.dialog && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom)) this.dialog.close();
      }, { signal });
      this.dialog?.addEventListener('close', () => {
        document.body.style.overflow = this.previousOverflow || '';
        this.quoteOpener?.focus();
      }, { signal });
      this.emailForm?.addEventListener('input', () => {
        if (this.emailForm.dataset.submitting !== 'true') {
          this.requestId = null;
          this.emailForm.querySelector('[data-email-status]').hidden = true;
        }
      }, { signal });
      this.emailForm?.addEventListener('submit', event => this.sendQuote(event), { signal });
      const form = this.querySelector('[data-ecomax-form]');
      if (form) {
        form.hidden = false;
        form.addEventListener('submit', () => {
          const labels = this.dataset.guideLabels.split('|');
          const fields = ['model', 'business', 'city'];
          const lines = fields.map((field, index) => `${labels[index]}: ${form.querySelector(`[data-field="${field}"]`).value.trim()}`);
          form.querySelector('[data-message]').value = this.attributeMessage([this.dataset.guideIntro, '', ...lines, '', this.dataset.pageUrl].join('\n'));
          this.track('guide', form.querySelector('[data-field="model"]').value);
        }, { signal });
      }
    }
    disconnectedCallback() {
      if (this.dialog?.open) this.dialog.close();
      this.controller?.abort();
    }
    openQuote(opener) {
      if (!this.dialog || !this.emailForm) return;
      this.quoteOpener = opener;
      const select = this.emailForm.elements.namedItem('model');
      if (this.emailForm.dataset.submitting !== 'true' && Array.from(select.options).some(option => option.value === opener.dataset.model)) {
        if (select.value !== opener.dataset.model) this.requestId = null;
        select.value = opener.dataset.model;
        this.emailForm.querySelector('[data-email-status]').hidden = true;
      }
      if (!this.dialog.open) {
        this.previousOverflow = document.body.style.overflow;
        this.dialog.showModal();
        document.body.style.overflow = 'hidden';
      }
      this.emailForm.elements.namedItem('name').focus();
      this.track('product-form', select.value, 'ecomax_quote_request_open');
    }
    async sendQuote(event) {
      event.preventDefault();
      const form = event.currentTarget;
      if (form.dataset.submitting === 'true' || !form.reportValidity()) return;
      const status = form.querySelector('[data-email-status]');
      const button = form.querySelector('[type=submit]');
      const buttonHtml = button.innerHTML;
      const values = new FormData(form);
      this.requestId ||= crypto.randomUUID();
      const payload = Object.fromEntries(['model','name','email','phone','business','city','message','website'].map(key => [key, String(values.get(key) || '').trim()]));
      payload.requestId = this.requestId;
      payload.source = this.dataset.pageUrl;
      payload.utm = Object.fromEntries(['utm_source','utm_medium','utm_campaign','utm_content','utm_term'].map(key => [key, new URLSearchParams(window.location.search).get(key) || '']));
      form.dataset.submitting = 'true';
      button.disabled = true;
      button.textContent = form.dataset.sending;
      status.hidden = true;
      try {
        const endpoint = new URL(form.dataset.endpoint, location.origin);
        if (!form.dataset.endpoint || (endpoint.protocol !== 'https:' && !['127.0.0.1','localhost'].includes(endpoint.hostname))) throw new Error('Invalid endpoint');
        const response = await fetch(endpoint, { method: 'POST', mode: 'cors', credentials: 'omit', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload), signal: AbortSignal.timeout(20000) });
        const result = await response.json();
        if (!response.ok || result.ok !== true || result.status !== 'sent') throw new Error('Delivery not accepted');
        status.textContent = form.dataset.success;
        status.dataset.kind = 'success';
        this.track('product-form', payload.model, 'ecomax_quote_request_sent');
      } catch {
        status.textContent = form.dataset.error;
        status.dataset.kind = 'error';
      } finally {
        status.hidden = false;
        form.dataset.submitting = 'false';
        button.disabled = false;
        button.innerHTML = buttonHtml;
      }
    }
    attributeMessage(message) {
      const base = message.split('\n\nUTM:')[0];
      const params = new URLSearchParams(window.location.search);
      const attribution = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term']
        .filter(key => params.get(key))
        .map(key => `${key}: ${params.get(key).replace(/[\r\n]/g, ' ').slice(0, 120)}`);
      return attribution.length ? `${base}\n\nUTM:\n${attribution.join('\n')}` : base;
    }
    track(source, model, eventName = 'ecomax_quote_click') {
      try {
        if (typeof window.gtag === 'function') window.gtag('event', eventName, { landing: 'lavalozas-ecomax', quote_source: source, product_model: model });
        if (typeof window.clarity === 'function') window.clarity('event', eventName);
      } catch {}
    }
  }
  customElements.define('ecomax-landing', EcomaxLanding);
})();
